import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Paper from '@mui/material/Paper';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import Grid from '@mui/material/Grid';
import Slider from '@mui/material/Slider';
import MuiInput from '@mui/material/Input';
import { styled } from '@mui/system';



export default function Invertir(props) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [value, setValue] = React.useState(Number(props.registro.monto_invertir));
  const [maximo, setMaximo] = React.useState(0.00)
  const [grabando, setGrabando] = React.useState(false)

  React.useEffect(()=>{
    console.log(props.registro)
    setMaximo((parseFloat(props.registro.disponible) * (props.maximo/100)).toFixed(2));
  }, [])

  const handleSliderChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleInputChange = (event) => {
    let valor = event.target.value === '' ? 0 : Number(event.target.value);
    if (valor>maximo){valor=maximo}
    setValue(valor);
  };

  const handleBlur = () => {
    if (value < 0) {
      setValue(0);
    } 
  };
  const handleClose = () => {
    props.close()
  };


  const handleGrabar = ()=>{
    if (puedeGrabar()){
      setGrabando(true)
      props.graba(value)
    }
  }

  const puedeGrabar = ()=>{
    return true;
  }



  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth={true}
      fullScreen={isMobile}
      PaperProps={{
        sx: {
          m: isMobile ? 0 : 2,
          maxHeight: isMobile ? '100%' : '90vh'
        }
      }}
    >
      <DialogTitle sx={{
        background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
        color: 'white',
        py: isMobile ? 1.5 : 2,
        fontSize: isMobile ? '1rem' : '1.25rem'
      }}>
        Detalle Inversión
      </DialogTitle>
      <DialogContent sx={{ p: isMobile ? 2 : 3 }}>
        <Paper sx={{
          padding: isMobile ? "12px" : "16px",
          marginBottom: "20px",
          marginTop: "16px",
          background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
          border: '1px solid rgba(30, 58, 95, 0.1)'
        }} elevation={2}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
            <Typography variant='caption' sx={{ color: '#4a5568' }}>Monto Préstamo:</Typography>
            <Typography variant={isMobile ? 'body2' : 'body1'} sx={{ fontWeight: "bold", color: '#1e3a5f' }}>
              {parseFloat(parseFloat(props.registro.balance).toFixed(2)).toLocaleString('en-US', {minimumFractionDigits: 2})}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
            <Typography variant='caption' sx={{ color: '#4a5568' }}>Cuotas Préstamo:</Typography>
            <Typography variant={isMobile ? 'body2' : 'body1'} sx={{ fontWeight: "bold", color: '#1e3a5f' }}>
              {props.registro.cuotas}
            </Typography>
          </Box>
          <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            pt: 1,
            borderTop: '1px solid rgba(30, 58, 95, 0.1)'
          }}>
            <Typography variant='caption' sx={{ color: '#4a5568' }}>Disponible para invertir:</Typography>
            <Typography variant={isMobile ? 'body2' : 'body1'} sx={{ fontWeight: "bold", color: '#d4af37' }}>
              {parseFloat(maximo).toLocaleString('en-US', {minimumFractionDigits: 2})}
            </Typography>
          </Box>
        </Paper>
        <Box>
          <Typography id="input-slider" gutterBottom sx={{ color: '#1e3a5f', fontWeight: 500 }}>
            ¿Cuánto desea invertir?
          </Typography>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={isMobile ? 12 : true} paddingTop={"4px"}>
              <Slider
                value={typeof value === 'number' ? value : 0}
                onChange={handleSliderChange}
                min={0}
                max={parseFloat(maximo)}
                step={100}
                aria-labelledby="input-slider"
                sx={{
                  color: '#1e3a5f',
                  '& .MuiSlider-thumb': {
                    backgroundColor: '#d4af37',
                  },
                  '& .MuiSlider-track': {
                    backgroundColor: '#2c5282',
                  }
                }}
              />
            </Grid>
            <Grid item xs={isMobile ? 12 : 'auto'}>
              <TextField
                variant="outlined"
                size={isMobile ? "medium" : "small"}
                value={value}
                type="number"
                onChange={handleInputChange}
                onBlur={handleBlur}
                fullWidth={isMobile}
                InputProps={{
                  sx: {
                    fontWeight: 'bold',
                    color: '#1e3a5f',
                    fontSize: isMobile ? '1.25rem' : '1rem'
                  }
                }}
              />
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions sx={{
        p: isMobile ? 2 : 2,
        gap: 1,
        flexDirection: isMobile ? 'column' : 'row'
      }}>
        <Button
          variant="outlined"
          onClick={handleClose}
          fullWidth={isMobile}
          sx={{
            order: isMobile ? 2 : 1,
            color: '#1e3a5f',
            borderColor: '#1e3a5f'
          }}
        >
          Cancelar
        </Button>
        <Button
          disabled={grabando}
          onClick={handleGrabar}
          variant="contained"
          fullWidth={isMobile}
          sx={{
            order: isMobile ? 1 : 2,
            background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
            '&:hover': {
              background: 'linear-gradient(135deg, #2c5282 0%, #3d6a9f 100%)'
            }
          }}
        >
          Invertir
        </Button>
      </DialogActions>
    </Dialog>
  );
}